import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { getGruser } from '../selectors';
import { getCanCreateGroupGalleryFolder, getCanRearrangeGroupGalleryFolders } from '../../utils/groupPrivs';
export const useGlobalPrivs = ()=>_object_spread({}, useMMSelector((state)=>{
        const gruser = getGruser(state);
        return {
            canRearrangeGalleryFolders: !(gruser === null || gruser === void 0 ? void 0 : gruser.isGroup) || getCanRearrangeGroupGalleryFolders(gruser.extendedGroup),
            canCreateGalleryFolder: !(gruser === null || gruser === void 0 ? void 0 : gruser.isGroup) || getCanCreateGroupGalleryFolder(gruser.extendedGroup)
        };
    }));
export default ((component)=>connectMediaStore((state)=>{
        const gruser = getGruser(state);
        return {
            canRearrangeGalleryFolders: !(gruser === null || gruser === void 0 ? void 0 : gruser.isGroup) || getCanRearrangeGroupGalleryFolders(gruser.extendedGroup),
            canCreateGalleryFolder: !(gruser === null || gruser === void 0 ? void 0 : gruser.isGroup) || getCanCreateGroupGalleryFolder(gruser.extendedGroup)
        };
    })(component)); // redux is a bit dumb with generics
